import script from "./RequestVoucher.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestVoucher.vue?vue&type=script&setup=true&lang=ts"

import "./RequestVoucher.vue?vue&type=style&index=0&id=fbd59480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbd59480"]])

export default __exports__